





























import {Component, Prop, Vue} from 'vue-property-decorator';
import {BadgeStore} from '../store/modules/badge.store';
import {WebService} from '@/services/web.service';
import {OverlayShowTime} from '@/constants';
import {TicketStore} from '@/store/modules/ticket.store';

@Component
export default class BadgeEdit extends Vue {
	@Prop({required: true})
	badgeId!: string;

	badgeName = '';

	showOverlay = false;
	showLoading = false;
	showCompletedOverlay = false;
	overlayMessage = '';

	get badge() {
		return BadgeStore.byId(this.badgeId);
	}

	created() {
		if(this.badge !== null) {
			this.badgeName = this.badge.name;
		} else {
			this.close();
		}
	}

	close() {
		this.showOverlay = false;
	}

	finalClose() {
		this.$emit('close');
	}

	get validBadgeName() {
		return BadgeStore.isValidBadgeName(this.badgeName);
	}

	async updateBadge() {
		if(!this.validBadgeName) {
			return;
		}
		try {
			this.showLoading = true;
			await WebService.updateBadge(this.badgeId, {
				name: this.badgeName
			});
			this.showLoading = false;
			this.overlayMessage = `Badge Updated!`;
			this.showCompletedOverlay = true;
			setTimeout(() => {
				this.showCompletedOverlay = false;
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk( 'There was a problem updating your badge', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}

	}

	async deleteBadge() {
		const foundTicket = TicketStore.ticketByBadgeId(this.badgeId);
		if(foundTicket !== null) {
			await this.$bvModal.msgBoxOk( 'You cannot delete a badge that has an active ticket attached to it.', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		} else {
			if(await this.$bvModal.msgBoxConfirm('Are you sure you delete this badge?', {
				centered: true,
				cancelTitle: 'Cancel',
				okTitle: 'Delete',
				okVariant: 'danger'
			})) {
				try {
					this.showLoading = true;
					await WebService.deleteBadge(this.badgeId);
					this.showLoading = false;
					this.overlayMessage = `Badge Deleted!`;
					this.showCompletedOverlay = true;
					setTimeout(() => {
						this.showCompletedOverlay = false;
						this.close();
					}, OverlayShowTime);
				} catch(e) {
					this.showLoading = false;
					await this.$bvModal.msgBoxOk( 'There was a problem deleting your badge', {
						title: 'Error',
						centered: true,
						okTitle: 'Ok'
					});
				}
			}
		}
	}
}
